import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { Breadcrumbs } from '../../../AbstractElements';
import UserList from './UserList';
import i18n from '../../../i18n';


const UserProfile = () => {

  

    return (
        <Fragment>
            <Breadcrumbs mainTitle={i18n.t('Dashboard_Breadcrumb_Users')} parent={i18n.t('Dashboard_Breadcrumb_Users')} title={i18n.t('Dashboard_Breadcrumb_UserList')} />
            <Container fluid={true}>
                <div className="edit-profile">
                    <Row>
                        <Col xl="12">
                            <UserList/>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default UserProfile;
